import React, { useContext } from 'react'
import { ItemType, Progress, TodoContext } from './Project';
import Todo from './Todo';

export default function TodoDone() {
  const {tasks} = useContext(TodoContext);
  const lines = tasks.filter(task => task.progress === Progress.Done && (task.itemType === ItemType.Task || !task.itemType));

  return (
    <Todo title='DONE!' lines={lines} titleStyle='titleDone'/>
  )
}
